import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {Block} from './Block'

export const EditAbleBlockHolder = ({
                                        icon = NullAsDefault,
                                        title,
                                        description,
                                        onClick,
                                    }) => (
    <Block className="cursor-pointer background-100 hover:background-200">
        <div
            onClick={onClick}
            className="flex w-full flex flex-col px-4 py-5 items-center opacity-75">
            {!!icon && icon()}
            <div className="font-semibold text-xl text-color-500">{title}</div>
            <div className="pt-3 font-semibold">{description}</div>
        </div>
    </Block>
)
